// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__2ZGog","mobile":"alert_mobile__1Rrpp"};